import * as React from "react";
import { InputProps } from "./form";
import { TextFieldProps } from "@mui/material/TextField/TextField";
import { Controller } from "react-hook-form";
import { TextField } from "@mui/material";

interface Props
    extends InputProps,
        Pick<TextFieldProps, "fullWidth" | "autoFocus" | "InputProps"> {
    label: React.ReactNode;
    autoComplete?: string;
}

const InputInner = (p: Props, _ref: React.ForwardedRef<HTMLDivElement>) => {
    return (
        <Controller
            name={p.name}
            control={p.control}
            render={(formProps) => {
                return (
                    <TextField
                        {...formProps.field}
                        autoFocus={p.autoFocus}
                        InputProps={{
                            autoComplete: p.autoComplete,
                            ...p.InputProps,
                        }}
                        required={p.required}
                        error={p.error}
                        helperText={p.helperText}
                        value={formProps.field.value || ""}
                        label={p.label}
                        fullWidth={p.fullWidth}
                        size={"small"}
                    />
                );
            }}
        />
    );
};

export const Input = React.forwardRef(InputInner);
